.eh{width:max-content;}